import { createContext } from 'react';

const defaultValue = {
  mode: 'onPage',
};

const Context = createContext(defaultValue);

export default Context;
